"use client";

import Button from "@/components/Button/Button.component";
import { BUTTON_SUBTYPE_CLASS } from "@/components/Button/Button.model";
import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { LeadershipFields, LeadershipPropsModel } from "./Leadership.model";

export function Leadership({ leadershipCollection }: LeadershipPropsModel) {
  return (
    <>
      {leadershipCollection.map((item: LeadershipFields, index: number) => {
        return (
          <div
            key={index}
            className={cn("bg-core-white px-4 py-20 md:py-10 lg:px-10")}
          >
            <div
              className={`flex flex-col md:flex-row ${item.imageAlignment.toLowerCase() === "right" ? "md:flex-row-reverse" : ""}`}
            >
              <div
                className={`mb-10 flex-1 md:mb-0 ${item.imageAlignment.toLowerCase() === "right" ? "md:flex md:flex-col md:items-end md:pl-4 lg:pl-8" : "md:pr-4 lg:pr-8"}`}
              >
                <div
                  className={`mb-6 ${item.imageAlignment.toLowerCase() === "right" ? "md:w-[240px]" : ""}`}
                >
                  <Typography.LLABEL2 className="mb-0.5">
                    {item.name}
                  </Typography.LLABEL2>
                  <Typography.LLABEL2>{item.designation}</Typography.LLABEL2>
                </div>
                <Image
                  src={`${item.image.url}?fm=webp`}
                  alt={item.name}
                  width={item.image.width || 0}
                  height={item.image.height || 0}
                  className="aspect-square h-[160px] w-[160px] rounded-full object-cover md:h-[240px] md:w-[240px]"
                />
              </div>
              <div className="flex-1">
                <div className="w-full antialiased">
                  {/* {description && (
                    <RichText
                      additionalClassName={{
                        paragraph: "!text-b1",
                        link: "!text-b1",
                      }}
                      content={description.json}
                    />
                  )} */}
                  <Typography.BODY1> {item.description} </Typography.BODY1>

                  <div className="mt-20">
                    <ul className="flex w-full flex-row gap-6">
                      <li>
                        <Link
                          className="transition-all duration-300 hover:opacity-50"
                          href={item.linkedInLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Image
                            width={24}
                            height={24}
                            src="/static/icons/linkedin.svg"
                            alt="LinkedIn"
                          />
                        </Link>
                      </li>

                      {item?.email && (
                        <li>
                          <Link
                            className="transition-all duration-300 hover:opacity-50"
                            href={`mailto:${item?.email}`}
                          >
                            <Image
                              width={24}
                              height={24}
                              src="/static/icons/email.svg"
                              alt="Email"
                            />
                          </Link>
                        </li>
                      )}

                      {item?.phone && (
                        <li>
                          <Link
                            className="flex flex-row gap-2 transition-all duration-300 hover:opacity-50"
                            href={`tel:${item?.phone}`}
                          >
                            <Image
                              width={24}
                              height={24}
                              src="/static/icons/phone.svg"
                              alt="Phone"
                            />
                            <Button
                              fullHeight={false}
                              primary={false}
                              type={BUTTON_SUBTYPE_CLASS.SECONDARY_BLACK}
                              content={{ text: item?.phone }}
                            />
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
